<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                Ratio
            </p>
        </header>
        <div class="card-content">
            <div class="content">
                <h1>{{ ratio }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            ratio() {
                return this.$store.getters.getProfitSectionData.ratio
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitRatio.vue